// extracted by mini-css-extract-plugin
export default {"oosNotify":"Z7-z","count":"_7-z","otherColors":"a8-z","modalContent":"b8-z","body":"c8-z"};